<!--
  - MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Website: https://www.4myth.com
  -->

<template>
  <v-container
    fluid
    v-bind="$attrs"
  >
    <v-row dense>
      <v-col
        v-if="title"
        cols="12"
      >
        <div
          class="text-h4 text-center mb-4"
          v-text="parseAttribute('contact_us')"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <template v-if="!!AppSettings.contact_us">
          <div v-html="AppSettings.contact_us" />
          <v-divider :class="`my-4 ${dividerColor || ''}`" />
        </template>
        <div v-if="!!AppSettings.commercial_name">
          {{ AppSettings.commercial_name }}
        </div>
        <div v-if="!!AppSettings.commercial_register">
          {{ parseAttribute('commercial_register') }}:&nbsp;{{ AppSettings.commercial_register }}
        </div>
        <div v-if="!!AppSettings.vat_number">
          {{ parseAttribute('vat_number') }}:&nbsp;{{ AppSettings.vat_number }}
        </div>
        <div
          v-if="!!AppSettings.address"
          v-html="AppSettings.address"
        />
      </v-col>
      <v-col
        v-if="AppSettings.google_map_url"
        class="text-center"
        cols="12"
        sm="6"
      >
        <v-card
          color="transparent"
          shaped
        >
          <iframe
            :src="AppSettings.google_map_url"
            allowfullscreen=""
            height="280"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
            style="border:0;"
            width="100%"
          />
        </v-card>
      </v-col>
    </v-row>
    <v-row
      v-if="AppContacts.length>0"
      class="mb-4"
      dense
    >
      <v-col cols="12">
        <v-toolbar
          :color="color"
          class="mb-2"
          dark
        >
          <v-toolbar-title>{{ parseAttribute('contact_data') }}</v-toolbar-title>
        </v-toolbar>
      </v-col>
      <v-col
        v-for="(contact,cdx) in AppContacts"
        :key="`${cdx}-contact`"
        cols="auto"
      >
        <v-btn
          :class="contact.class"
          :color="btnColor || contact.color"
          :href="contact.url || undefined"
          :icon="!contact.label"
          :link="!!contact.url"
          :text="!!contact.label && !!contact.icon"
          v-bind="contact.attrs"
        >
          <v-icon
            v-if="!!contact.icon"
            left
          >
            {{ contact.icon }}
          </v-icon>
          <span
            v-if="!!contact.label"
            :class="contact.span"
          >{{ contact.label }}</span>
        </v-btn>
      </v-col>
    </v-row>
    <v-row
      v-if="AppSocials.length>0"
      dense
      justify="center"
    >
      <v-col cols="12">
        <v-toolbar
          :color="color"
          dark
        >
          <v-toolbar-title>{{ parseAttribute('follow_us') }}</v-toolbar-title>
        </v-toolbar>
      </v-col>
      <v-col
        v-for="(social,k) in AppSocials"
        :key="`${k}-Socials`"
        cols="auto"
      >
        <v-btn
          :color="btnColor || social.color"
          :href="social.url || undefined"
          :icon="!social.label"
          :class="social.class"
          v-bind="social.attrs"
        >
          <v-icon v-if="!!social.icon">
            {{ social.icon }}
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ContactUsData',
  props: {
    title: {
      type: Boolean,
      required: false,
      default: false
    },
    color: {
      type: String,
      required: false,
      default: 'primary'
    },
    dividerColor: {
      type: String,
      required: false,
      default: undefined
    },
    btnColor: {
      type: String,
      required: false,
      default: undefined
    }
  }
}
</script>
